import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ViewTablePage, ViewTablePagedData, ViewTableService } from '../modules/data-view-table/view-table.service';
import { AppService } from './app.service';
import { HttpService } from '@hss-m/uikit-common';
import { BaseService } from 'src/app/pages/private/common/classes/base.service';
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class DiscoverService extends BaseService {
  collections;
  constructor (
    override readonly http: HttpClient,
    private viewTableService: ViewTableService,
    override readonly appService: AppService,
    override readonly httpService: HttpService
  ) {
    super(http, appService, httpService)
  }

  getCollectionTypes(): Observable<any> {
    if(this.collections) {
      return of(this.collections);
    }
    return this.http.get(`${this.appBaseUrl}/collections/types`).pipe(map((res: any) => {
      this.collections = (res?.types || []).map((collection, index) => ({...collection, index}));
      return cloneDeep(this.collections);
    }));
  }

  getCollections(page: Partial<ViewTablePage>, sort: any, filters: any): Observable<ViewTablePagedData> {
    return this.viewTableService.getData(`${this.appBaseUrl}/collections`, page, sort, filters, 'collections');
  }

  getCollectionBySlug(slug: string): Observable<any> {
    return this.http.get(`${this.appBaseUrl}/collections/${slug}`);
  }

  getCollectionProducts(slug: string, page: Partial<ViewTablePage>, sort: any, filters: any): Observable<ViewTablePagedData> {
    return this.viewTableService.getData(
      `${this.appBaseUrl}/collections/${slug}/products`,
      page, 
      sort, 
      filters, 
      'products'
    );
  }

  getPopularRecommendations (slug: string, page: Partial<ViewTablePage>, sort: any, filters: any):Observable<ViewTablePagedData> {
  //  return this.getCollectionProducts(slug,page,sort, filters )
  return this.viewTableService.getData(
    `${this.appBaseUrl}/collections/${slug}/products`,
    page, 
    sort, 
    filters, 
    'products'
  );
  }

  getTrendingProductsForDiscovery(data: any): Observable<any> {
    return this.http.get(`${this.appBaseUrl}/collections/trending?limit=${data.limit}&offset=${data.offset}`)
  }

  getTrendingProducts(page: Partial<ViewTablePage>, sort: any, filters: any): Observable<ViewTablePagedData> {
    return this.viewTableService.getData(`${this.appBaseUrl}/collections/trending`, page, sort, filters, 'products');
  }

  apiUrl(): string {
    return this.appBaseUrl;
  }

}
